import React from "react";
import { DiscountsContextInterface } from "types/discounts";

export const DiscountsContext = React.createContext<DiscountsContextInterface>({
  discounts: [],
  hasDiscounts: false,
  applyDiscounts: () => {},
});
